<template>
  <div
    class="input-file-drop-box"
    :data-active="active"
    @dragenter.prevent="setActive"
    @dragover.prevent="setActive"
    @dragleave.prevent="setInactive"
    @drop.prevent="onDrop"
  >
    <slot :dropZoneActive="active"></slot>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue'

defineProps({
  disabled: { type: Boolean, default: false }
})
interface EMITS {
  (e: 'files-dropped', val: File[])
}
const emits = defineEmits<EMITS>()
const events = ['dragenter', 'dragover', 'dragleave', 'drop']
const active = ref(false)
let inActiveTimeout: any = null

function onDrop(event: DragEvent) {
  setInactive()
  emits('files-dropped', event.dataTransfer?.files ? [...event.dataTransfer.files] : [])
}

function preventDefaults(event) {
  event.preventDefault()
}
function setActive() {
  active.value = true
  clearTimeout(inActiveTimeout)
}
function setInactive() {
  inActiveTimeout = setTimeout(() => {
    active.value = false
  }, 50)
}

onMounted(() => {
  events.forEach((eventName) => {
    document.body.addEventListener(eventName, preventDefaults)
  })
})

onUnmounted(() => {
  events.forEach((eventName) => {
    document.body.removeEventListener(eventName, preventDefaults)
  })
})
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins';
.input-file-drop-box {
  border-radius: 12px;
  border: 1px dashed variables.$color-greyscale-secondary;
  height: 120px;
}
</style>
